import React from 'react';
import { Meteor } from 'meteor/meteor';

import {
  Table,
} from '@sketchpixy/rubix';

export class Tableau extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
		this.state.data = props.data;
		this.state.columnCount = props.data.datasets.length;
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data: nextProps.data,
			columnCount: nextProps.data.datasets.length
		});
	}

	calculTotal(index) {
		let total = 0;
		_.each(this.state.data.datasets[index].data, (data) => {
			total += data;
		});

		return total;
	}

	renderData(label, index) {
		return this.state.data.datasets.map((item) => (
			<td>{item.data[index]}</td>
		));
	}

	renderRow() {
		return this.state.data.labels.map((label, index) => (
			<tr>
				<td>{ label }</td>
				{this.renderData(label, index)}
			</tr>
		));
	}

	renderHead() {
		return this.state.data.datasets.map((item) => (
			<th>{item.label}</th>
		));
	}

	renderTotal() {
		return (
			<tr>
				<td>Total</td>
				{this.state.data.datasets.map((item, index) => (
					<td>{ this.calculTotal(index) }</td>
				))}
			</tr>
		);
	}

	render() {
		return (
			<div>
				<Table striped bordered condensed hover>
					<thead>
						<tr>
							<th> - </th>
							{this.renderHead()}
						</tr>
					</thead>
					<tbody>
						{this.renderRow()}
					</tbody>
					<thead style={{backgroundColor: '#89949B', color: 'white'}}>
						{this.renderTotal()}
					</thead>
				</Table>
			</div>
		);
	}

}



/** WEBPACK FOOTER **
 ** ./src/universal/components/statistiques/Tableau.component.js
 **/